module.exports = {
    zh: {
        Phone: '手机号码',
        Chinesename: '中文姓名',
        Englishname: '英文姓名',
        attendanceGroup:'考勤组名称',
        attendanceStaff:'参与考勤人员',
        shift:'班次',
        addshift:'新增班次',
        editshift:'编辑班次',
        changeshift:'更改班次',
        addGroup:'新增考勤组',
        editGroup:'编辑考勤组',
        specialDate:'特殊日期',
        Chilsname: '宝宝姓名',
        Classname:'班次名称',
        Classsetting:'班次设置',
        beginwork:'上班',
        endwork:'下班',
        restbegin:'休息开始',
        restend:'休息结束',
        AffiliatedPark: '所属园区',
        isAccount: '是否分配账户',
        initiatemode:'启用状态',
        search: '搜索',
        reset: '重置',
        add: '添加',
        allocatedaccount: '分配账户',
        Enable: '启用',
        Disable: '禁用',
        Import: '导入',
        export: '导出',
        Downloadingstencil: '下载导入模版',
        see: '查看',
        delete: '删除',
        resetPassword:'重置密码',
        operation: '操作',
        number:'序号',
        Essentialinformation: '基本信息',
        edit: '编辑',
        save: '保存',
        cancel: '取消',
        save1: '提交',
        photo: '照片',
        email: '邮箱',
        nation: '民族',
        sex: '性别',
        Documenttype: '证件类型',
        IDNO: '证件号码',
        dateofbirth: '出生日期',
        maritalstatus: '婚姻状况',
        nationality: '国籍',
        education: '学历',
        address: '家庭住址',
        unitname:'单位名称',
        position: '职位',
        Unitaddress: '单位地址',
        Children: '孩子',
        age: '年龄',
        class: '班级',
        relationship: '关系',
        Allowdelivery: '允许接送',
        emergencycontact: '紧急联系人',
        Live: '与孩子居住',
        Associatedchildren: '关联孩子',
        yes:'是',
        no: '否',
        relation: "关联",
        modify: "修改",
        code:"编号",
        studentType:"学生类型",
        staffChild:"职工子女",
        planClass:"计划班级",
        foreignNation:"海外华人",
        nowAddress:"现住址",
        local:"户口所在地",
        firstCare:"第一监护人",
        secondCare:"第二监护人",
        blood:"血型",
        health:"健康状况",
        disable:"是否残疾",
        onlyChild:"是否独生子女",
        orphan:"是否孤儿",
        lowHouse:"是否低保家庭",
        leftChild:"是否留守儿童",
        guardian:"监护人",
        relateGuardian:"关联监护人",
        enterGarden: "入园",
        leaveGarden: "离园",
        signAddress:"打卡地点",
        latitude:"纬度",
        longitude:"经度",
        signDistance:"打卡范围",
        metre:"米"
    },
    en: {
        Phone: 'Phone',
        Chinesename: 'Chinese name',
        Englishname: 'English name',
        attendanceGroup:'Name of attendance group',
        attendanceStaff:'Attendance staff',
        shift:'shift',
        addshift:'New shift',
        editshift:'Edit class',
        changeshift:'Change the flight',
        addGroup:'New attendance group',
        editGroup:'Editorial attendance group',
        specialDate:'Special date',
        Chilsname: 'Chils name',
        Classname:'Classname',
        Classsetting:'Classsetting',
        beginwork:'beginwork',
        endwork:'endwork',
        restbegin:'Start with rest',
        restend:'End of rest',
        AffiliatedPark: 'Affiliated Park',
        isAccount: 'is Account',
        initiatemode:'initiat emode',
        search: 'search',
        reset: 'reset',
        resetPassword:'reset password',
        add: 'add',
        allocatedaccount: 'allocatedaccount',
        Enable: 'Enable',
        Disable: 'Disable',
        Import: 'Import',
        export: 'export',
        Downloadingstencil: 'Downloadingstencil',
        see: 'see',
        delete: 'delete',
        operation: 'operation',
        number:'number',
        Essentialinformation: 'Essential information',
        edit: 'edit',
        save: 'save',
        cancel: 'cancel',
        save1: 'submit',
        photo: 'cancel',
        email: 'email',
        nation: 'nation',
        sex: 'sex',
        Documenttype: 'Documenttype',
        IDNO: 'IDNO',
        dateofbirth: 'dateofbirth',
        maritalstatus: 'maritalstatus',
        nationality: 'nationality',
        education: 'education',
        address: 'address',
        unitname:'unit name',
        position: 'position',
        Unitaddress: 'Unit address',
        Children: 'Children',
        age: 'age',
        class: 'class',
        relationship: 'relationship',
        Allowdelivery: 'Allowde livery',
        emergencycontact: 'emergency contact',
        Live: 'Live width children',
        Associatedchildren: 'Associated children',
        yes:'YES',
        no: 'NO',
        relation: "relation",
        modify: "modify",
        code:'code',
        studentType:"studentType",
        staffChild:"staffChild",
        planClass:'planed class',
        foreignNation:"overseas Chinese",
        nowAddress:"nowAddress",
        local:"Hukou",
        firstCare:"First Guardian",
        secondCare:"Second Guardian",
        blood:"Blood Type",
        health:"health condition",
        disable:"disabled",
        onlyChild:"only-child",
        orphan:"orphan",
        lowHouse:"Subsistence family",
        leftChild:"leftover children",
        guardian:"guardian",
        relateGuardian:"relateGuardian",
        enterGarden: "enterGarden",
        leaveGarden: "leaveGarden",
        signAddress:"signAddress",
        latitude:"latitude",
        longitude:"longitude",
        signDistance:"signDistance",
        metre:"metre"

    }
  
  }
  


// WEBPACK FOOTER //
// ./src/components/i18n/lang/parentsManagement.js